<div  v-if="shouldRenderConfig" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-bind:class="activeClass()" v-on:click="setActiveProductPartName(code)">
        {{name}}
    </button>
</div>